import { useColors, useInvertedThemeColorValues } from '@composite';
import { Slider } from '@material-ui/core';
import { Paragraph } from '@themed';
import { Institution } from '@types';
import React from 'react';
import { Flex, SxProps } from 'theme-ui';
import { internationalSliderStyle, labelStyle } from './InternationalChartItem.styles';

interface InternationalChartComponentProps extends SxProps {
  current: boolean;
  institution: Institution;
  valueChangeHandler: (newValue: number | number[], index: number) => void;
  index: number;
}

export const InternationalChartItem = React.forwardRef<HTMLDivElement, InternationalChartComponentProps>(
  ({ institution, current, index: i, valueChangeHandler }, ref) => {
    const [[compareColor, currentColor]] = useColors();
    const [compareTextColor, currentTextColor] = useInvertedThemeColorValues();
    const totalLabel = institution.total.toFixed(2).toString();

    return (
      <Flex ref={ref} sx={internationalSliderStyle(current ? currentColor : compareColor)}>
        <Slider value={institution.total * 10} onChange={(_, newValue) => valueChangeHandler(+newValue / 10, i)} step={1} min={0} max={100} />
        <Paragraph sx={{ ...labelStyle, color: current ? currentTextColor : compareTextColor }}>{totalLabel}</Paragraph>
      </Flex>
    );
  }
);
